import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, LogOut } from "lucide-react";
import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

const navClass = ({ isActive }) => `nav-link ${isActive ? "active" : ""}`;

export function Layout({ children }) {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [talentCount, setTalentCount] = useState(null);
  const navigate = useNavigate();
  const dashboardPath = user?.role === "admin" ? "/admin" : "/talent-dashboard";

  useEffect(() => { api.get("/talents").then((r) => setTalentCount(r.data.length)).catch(() => {}); }, []);

  const close = () => setOpen(false);
  const links = (
    <>
      <NavLink to="/talent" className={navClass} data-testid="nav-talent" onClick={close}>Talent {talentCount !== null && <sup className="text-[11px] text-neutral-500 ml-0.5">({talentCount})</sup>}</NavLink>
      <NavLink to="/cek-order" className={navClass} data-testid="nav-cek-order" onClick={close}>Cek Order</NavLink>
      <NavLink to="/syarat" className={navClass} data-testid="nav-terms" onClick={close}>Ketentuan</NavLink>
    </>
  );
  const authPill = user ? (
    <div className="inline-flex items-center gap-1 rounded-full bg-neutral-100 p-1.5" data-testid="nav-auth-pill">
      <Link to={dashboardPath} className="h-10 px-5 rounded-full bg-white text-sm font-medium text-neutral-900 inline-flex items-center shadow-sm" data-testid="nav-dashboard" onClick={close}>Dashboard</Link>
      <button className="h-10 px-4 rounded-full text-sm font-medium text-neutral-700 inline-flex items-center gap-1.5 hover:text-neutral-900" data-testid="nav-logout" onClick={async () => { await logout(); close(); navigate("/"); }}><LogOut size={15} strokeWidth={1.75} />Keluar</button>
    </div>
  ) : (
    <div className="inline-flex items-center gap-1 rounded-full bg-neutral-100 p-1.5" data-testid="nav-auth-pill">
      <Link to="/login" className="h-10 px-5 rounded-full text-sm font-medium text-neutral-700 inline-flex items-center hover:text-neutral-900" data-testid="nav-login" onClick={close}>Masuk</Link>
      <Link to="/daftar-talent" className="h-10 px-5 rounded-full bg-white text-sm font-medium text-neutral-900 inline-flex items-center shadow-sm" data-testid="nav-daftar-talent" onClick={close}>Daftar Talent</Link>
    </div>
  );

  return (
    <div className="min-h-screen flex flex-col">
      <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-neutral-100">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-20 flex items-center justify-between gap-6">
          <Link to="/" className="flex items-center" data-testid="nav-brand">
            <img src="/logo.png" alt="Sudut Nadi" className="h-16 w-auto" />
          </Link>
          <nav className="hidden md:flex items-center gap-10">{links}</nav>
          <div className="hidden md:block">{authPill}</div>
          <button className="md:hidden p-2 rounded-full hover:bg-neutral-100" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
            {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
          </button>
        </div>
        {open && (
          <nav className="md:hidden border-t border-neutral-100 bg-white px-5 py-4 flex flex-col gap-3" data-testid="nav-mobile-menu">
            <div className="flex flex-col gap-1">{links}</div>
            {authPill}
          </nav>
        )}
      </header>
      <main className="flex-1">{children}</main>
      <footer className="border-t border-neutral-100 mt-20">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
          <div>
            <img src="/logo.png" alt="Sudut Nadi" className="h-12 w-auto" />
            <p className="text-sm text-neutral-500 mt-3 leading-relaxed">Tempat nyaman untuk bercerita.</p>
          </div>
          <div className="text-sm text-neutral-700 flex flex-col gap-2">
            <Link to="/syarat" className="hover:underline" data-testid="footer-terms">Syarat & Ketentuan dan Privasi</Link>
            <Link to="/daftar-talent" className="hover:underline">Bergabung sebagai Talent</Link>
            <Link to="/cek-order" className="hover:underline">Cek Status Order</Link>
          </div>
          <div className="text-sm text-neutral-600 leading-relaxed" data-testid="footer-disclaimer">
            <p className="font-medium text-neutral-800">Bukan layanan psikolog/terapi profesional.</p>
            <p className="mt-1">Jika kamu dalam kondisi darurat atau memiliki pikiran untuk menyakiti diri, hubungi layanan darurat 112 atau hotline kesehatan jiwa Kemenkes 119 ext. 8.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
